import {Component, ElementRef, inject, input, model, output, signal, ViewChild} from '@angular/core';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {FormsModule} from '@angular/forms';
import {ChunkUploadService} from '../../../shared/services/chunk-uploader-service';
import {ResizedImage} from '../../../shared/components/resized-image/resized-image';

@Component({
  selector: 'app-upload-extra-images',
  imports: [
    ToggleSwitch,
    FormsModule,
    ResizedImage
  ],
  templateUrl: './upload-extra-images.html',
  styleUrl: './upload-extra-images.css',
})
export class UploadExtraImages extends AppBaseComponent {
  @ViewChild('fileInput2') fileInput!: ElementRef<HTMLInputElement>;
  standalone = input(false);
  isPrivate = model(false);
  images = signal<string[]>([]);
  uploadService = inject(ChunkUploadService)
  progress = signal(0);
  saved = output();
  onBack = output();

  uploading = signal(false);

  constructor() {
    super();
    this.images.set(this.authService.user()?.extra_images || [])
  }

  select() {
    this.fileInput.nativeElement.click();
  }

  protected onFileSelected($event: Event) {
    const input = $event.target as HTMLInputElement;
    if (input.files == null) return;
    const files: File[] = Array.from(input.files);

    if (files?.length) {
      files.slice(0, 9).forEach(async file => {
        this.uploading.set(true);
        await this.uploadService.upload({
          file: file,
          url: 'upload-user-image',
          onProgress: (progress) => this.progress.set(progress),
          onError: () => {
          }
        }).then((res: any) => {
          this.images.update((images: any) => [...images, res.file]);
          this.http.post('user/set-extra-image', {'image': res.file}).subscribe(res => {
            this.uploading.set(false);
            if (this.standalone()) {
              this.messageService.add({
                severity: 'custom',
                key: 'headless',
                summary: 'Profile updated successfully',
              })
            }
          });
        });
      });

    }
    input.value = '';
  }

  updatePrivacy() {
    this.http.post('user/update-basic-info', {field: 'private_images', value: this.isPrivate()}).subscribe();
  }

  deleteImage(file: string) {
    this.http.post('user/delete-extra-image', {file: file}).subscribe({
      next: (res) => {
        this.images.set(this.images().filter((img: string) => img != file))
      }
    });
  }
}
